import type { ThirdPartyFeeConfig, ThirdPartyFeeConfigApiPayload } from '@openx/types/deal';
import { ThirdPartyFeeConfigRevenueMethod } from '@openx/types/gqlTypes';
import { percentToMicroWithPrecision } from '@openx/utils/lib/percentToMicro';

export const formatThirdPartyFeesConfig = (
  isEnabled: boolean,
  thirdPartyFeesConfig: ThirdPartyFeeConfig[],
  canWritePlatformShare = true
): null | [ThirdPartyFeeConfigApiPayload] => {
  if (!isEnabled) {
    return null;
  }

  // currently API supports config for only one third party fee
  const config = thirdPartyFeesConfig.at(0);
  const isCpmRevenue = config?.revenue_method === ThirdPartyFeeConfigRevenueMethod.Cpm;

  if (!config) {
    return null;
  }

  return [
    {
      gross_cpm_cap: isCpmRevenue ? config.gross_cpm_cap : null,
      gross_share: isCpmRevenue ? null : percentToMicroWithPrecision(config.gross_share),
      partner_id: config.partner_id ?? '',
      platform_partner_id: config.platform_partner_id,
      ...(canWritePlatformShare && {
        platform_share: percentToMicroWithPrecision(config.platform_share),
      }),
      revenue_method: config.revenue_method,
    },
  ];
};
